import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import s from "../styles/header.module.css";

export default function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // закрываем меню при переходе по ссылке/роуту
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className={s.header}>
      <div className={s.blur_back}></div>

      <div className={s.logo}>
        <img src="/designs/logo.webp" alt="Logo" />
      </div>

      {/* меню; на мобилке это выезжающая панель */}
      <nav className={`${s.nav} ${open ? s.nav_open : ""}`}>
        <Link to="/">Home</Link>
        <Link to="/apps">Our Apps</Link>
        <Link to="/apps/support">Support</Link>
      </nav>

      {/* бургер / крестик */}
      <button
        type="button"
        className={`${s.burger} ${open ? s.burger_active : ""}`}
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Toggle navigation"
        aria-expanded={open}
      >
        <span className={s.burger_line}></span>
        <span className={s.burger_line}></span>
        <span className={s.burger_line}></span>
      </button>
    </header>
  );
}
